import { defineComponent, ref, computed, watch, nextTick } from "vue";
import { storeToRefs } from "pinia";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import { EventType } from "../../services/types.mjs";
import { useI18n } from "../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import Dialog from "../common/base/Dialog/index.mjs";
import TuiButton from "../common/base/Button.vue.mjs";
import Input from "../common/base/Input/index.mjs";
import CloseInputIcon from "../common/icons/CloseInputIcon.vue.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import { invalidPasswordRegex } from "../../utils/common.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PasswordDialog",
  props: {
    visible: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const basicStore = useBasicStore();
    const { roomId } = storeToRefs(basicStore);
    const { t } = useI18n();
    const inputPassword = ref("");
    const isShowPasswordContainer = ref(false);
    const isJoiningRoom = ref(false);
    const isJoinButtonDisable = computed(
      () => inputPassword.value.length === 0 || isJoiningRoom.value
    );
    watch(
      () => props.visible,
      (val) => {
        isShowPasswordContainer.value = val;
      },
      {
        immediate: true
      }
    );
    async function joinRoom() {
      try {
        isJoiningRoom.value = true;
        await roomService.join(roomId.value, {
          isOpenCamera: false,
          isOpenMicrophone: true,
          password: inputPassword.value
        });
        roomService.emit(EventType.ROOM_JOIN);
      } catch (error) {
        isJoiningRoom.value = false;
      }
    }
    function cancelInputPassword() {
      inputPassword.value = "";
      roomService.emit(EventType.ROOM_ERROR);
    }
    watch(
      () => inputPassword.value,
      async (val) => {
        if (val && invalidPasswordRegex.test(val)) {
          await nextTick();
          inputPassword.value = val.replace(invalidPasswordRegex, "");
        }
      }
    );
    return { __sfc: true, basicStore, roomId, t, inputPassword, props, isShowPasswordContainer, isJoiningRoom, isJoinButtonDisable, joinRoom, cancelInputPassword, TuiDialog: Dialog, TuiButton, TuiInput: Input, CloseInputIcon, svgIcon: SvgIcon };
  }
});
export {
  _sfc_main as default
};
